var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"kf-select",attrs:{"value":_vm.productType,"items":_vm.items,"label":"Product","hide-details":"","dense":"","outlined":""},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }